<div class="scatter-graph">
  <div class="container">
    <div class="y-axis">
      <div class="visualization-name">SCATTER GRAPH</div>

      <div class="buttons">
        <app-gv-button-group label="Y Axis" icon="label:y-axis" [variables]="variables" [type]="yAxisType"
                             [selected]="currentVariable('y')" [defaultVariable]="defaultYAxisVariable"
                             [vertical]="true" (variableChange)="variableChanged($event, 'y')"></app-gv-button-group>
      </div>
    </div>
    <div class="visualization">
      <div class="visualization-area">
        <dvl-visualization [data]="data" #visualization></dvl-visualization>
      </div>
      <div class="x-axis-buttons">
        <app-gv-button-group label="X Axis" icon="label:x-axis" [variables]="variables" [type]="xAxisType"
                             [selected]="currentVariable('x')" [defaultVariable]="defaultXAxisVariable"
                             (variableChange)="variableChanged($event, 'x')">
        </app-gv-button-group>
      </div>
    </div>
    <div class="graphic-variables-selection">
      <div>
        <app-gv-button-group label="Color" icon="label:color" [variables]="variables" [type]="colorType"
                             [selected]="currentVariable('color')" [vertical]="true"
                             (variableChange)="variableChanged($event, 'color')">
        </app-gv-button-group>
      </div>
      <div>
        <app-gv-button-group label="Shape" icon="label:shape" [variables]="variables" [type]="shapeType"
                             [selected]="currentVariable('shape')" [vertical]="true"
                             (variableChange)="variableChanged($event, 'shape')">
        </app-gv-button-group>
      </div>
      <div>
        <app-gv-button-group label="Size" icon="label:size" [variables]="variables" [type]="sizeType"
                             [selected]="currentVariable('areaSize')" [vertical]="true"
                             (variableChange)="variableChanged($event, 'areaSize')">
        </app-gv-button-group>
      </div>
    </div>
  </div>
</div>
